export type VerificationAction = "signup" | "pin_recovery";

interface TurnstileOptions {
  sitekey: string;
  action: VerificationAction;
  theme: "auto";
  size: "flexible" | "compact";
  appearance: "interaction-only";
  "before-interactive-callback": () => void;
  callback: (token: string) => void;
  "error-callback": () => void;
  "expired-callback": () => void;
  "timeout-callback": () => void;
}

export interface TurnstileApi {
  render: (element: HTMLElement, options: TurnstileOptions) => string;
  remove: (id: string) => void;
}

declare global {
  interface Window {
    turnstile?: TurnstileApi;
  }
}

export function turnstileConfig() {
  const siteKey =
    document.querySelector<HTMLMetaElement>('meta[name="turnstile-site-key"]')
      ?.content ?? "";
  const required =
    document.querySelector<HTMLMetaElement>('meta[name="turnstile-required"]')
      ?.content === "true";
  return { siteKey, required: required || Boolean(siteKey) };
}

let loading: Promise<TurnstileApi> | null = null;

export function loadTurnstile(): Promise<TurnstileApi> {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (loading) return loading;
  loading = new Promise<TurnstileApi>((resolve, reject) => {
    const script = document.createElement("script");
    const fail = () => {
      clearTimeout(timer);
      script.remove();
      loading = null;
      reject(new Error("Verification unavailable"));
    };
    const timer = setTimeout(fail, 10_000);
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.onload = () => {
      if (!window.turnstile) return fail();
      clearTimeout(timer);
      resolve(window.turnstile);
    };
    script.onerror = fail;
    document.head.appendChild(script);
  });
  return loading;
}
